import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { responseGet, globalSettings, dateTimeFormatGlobalSet, sendMessageCloseCurrentWindowAsync, separatorsNumbersSet, languageObjGet, isUndNullEmp, styles, awaitDelay } from '../../helpers/settings'
import { bankAccountMovementModelGet } from '../../models/bankAccounts/bankAccountMovement';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { purchaseModelGet } from '../../models/expenses/purchase';
import { supplierModelGet } from '../../models/expenses/suppliers';

const currentMethod = 'BankAccountMovementDetails';

const { bank, collections: dbColle, icons, labels, } = globalSettings;

export default function BankAccountMovementDetails({
    $ = {},
    auth = {},
    bankAccountMovement = {
        ...bankAccountMovementModelGet({}),
        purchase: {
            purchase: purchaseModelGet({}),
            supplier: supplierModelGet({}),
        },
    },
    showModal = false,
    setShowModal = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const chkReconcileId = 'chkReconcile';
    const [movementType, setMovementType] = useState(0);
    const [movementDate, setMovementDate] = useState('');
    const [controlNumber, setControlNumer] = useState('');
    const [movementOrigin, setMovementOrigin] = useState('');
    const [userConcilation, setUserConcilation] = useState('');
    const [movementCollection, setMovementCollection] = useState('');
    const [supplier, setSupplier] = useState(supplierModelGet({}));
    const [movementOriginDate, setMovementOriginDate] = useState('');
    const [movementOriginNumber, setMovementOriginNumber] = useState('');
    const [movementOriginDocument, setMovementOriginDocument] = useState('');
    const [movementTypeDescription, setMovementTypeDescription] = useState('');
    const [movementConcilationDate, setMovementConcilationDate] = useState('');
    const [movementConcilationRemark, setMovementConcilationRemark] = useState('');
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnBankAccountMovementDetailsModalSave',
                className: 'btn btn-outline-primary mx-1',
                classNameTwo: 'btn btn-outline-warning mx-1',
            },
            back: {
                id: 'btnBankAccountMovementDetailsModalBack',
                className: 'btn btn-outline-success',
            },
            close: {
                id: 'btnBankAccountMovementDetailsModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        dataTables: {
            // movements: {
            //     buttons: {
            //         // detailAdd: {
            //         //     className: 'btn btn-sm btn-outline-info mx-1 float-right',
            //         //     id: 'btnDtPurchaseDetailsIdDetailAdd',
            //         // },
            //     },
            //     icons: {
            //         // detailAdd: {
            //         //     id: 'iconDtPurchaseDetailsIdDetailAdd',
            //         //     className: icons?.list,
            //         // },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtMovementsId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtMovementsId}_length select`,
            //             className: '',
            //         },
            //     },
            //     // spinners: {
            //     //     detailAdd: {
            //     //         id: 'spDtPurchaseDetailsIdDetailAdd',
            //     //         className: '',
            //     //     },
            //     // },
            // },
        },
        icons: {
            save: {
                id: 'icoBankAccountMovementDetailsModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoBankAccountMovementDetailsModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoBankAccountMovementDetailsModalClose',
                className: '',
            },
        },
        inputs: {
            date: {
                id: 'inputBankAccountMovementDetailsModalDate',
                className: 'form-control datetimepicker-input',
            },
            amount: {
                id: 'inputBankAccountMovementDetailsModalAmount',
                className: 'form-control text-right',
            },
            reference: {
                id: 'inputBankAccountMovementDetailsModalReference',
                className: 'form-control',
            },
            remark: {
                id: 'inputBankAccountMovementDetailsModalRemark',
                className: 'form-control',
            },
        },
        radioButtons: {
            // all: {
            //     id: 'rButonAll',
            //     className: 'icheck-primary d-inline',
            //     name: 'radioButtonName',
            // },
        },
        selects: {
            type: {
                id: 'selBankAccountMovementDetailsModalType',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spBankAccountMovementDetailsModalSave',
                className: '',
            },
            back: {
                id: 'spBankAccountMovementDetailsModalBack',
                className: '',
            },
            close: {
                id: 'spBankAccountMovementDetailsModalClose',
                className: '',
            },
        },
    };
    //#endregion others

    //#region methods
    const datGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'datGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let subTypeLocal = {
                id: '',
                description: {},
            };
            let movementTypeLocal = 0;
            let momeventDateLocal = '';
            let momeventConcilationDateLocal = '';
            let momeventConcilationRemarkLocal = '';
            //#endregion variables

            //#region validations
            if (!isUndNullEmp({ data: bankAccountMovement?.collection, subMethod: currentMethod, })?.result) {
                setMovementCollection(bankAccountMovement?.collection);
                switch (bankAccountMovement?.collection) {
                    case dbColle?.apartmentReceiptPayments:
                        movementTypeLocal = 1;
                        setMovementOrigin(labels?.apartment?.[languageObj?.id]);
                        break;
                    case dbColle?.purchasePayments:
                        movementTypeLocal = -1;
                        setMovementOrigin(labels?.purchase?.[languageObj?.id]);
                        break;
                    case dbColle?.bankAccountMovements:
                        if (!isUndNullEmp({ data: bankAccountMovement?.movement?.type, subMethod: currentMethod, })?.result) {
                            setMovementOrigin(labels?.bankAccountMovement?.[languageObj?.id]);
                            if (!isUndNullEmp({ data: bankAccountMovement?.movement?.subType, subMethod: currentMethod, })?.result) {
                                subTypeLocal = bank?.transactionTypes.find(({ id }) => id === bankAccountMovement?.movement?.subType) || {};
                                setMovementOriginNumber(subTypeLocal?.description?.[languageObj?.id] || '');
                            }
                            switch (bankAccountMovement?.movement?.type) {
                                case 'E':
                                    movementTypeLocal = -1;
                                    break;
                                case 'I':
                                    movementTypeLocal = 1;
                                    break;
                                default:
                                    movementTypeLocal = 0;
                                    break;
                            }
                        } else {
                            movementTypeLocal = 0;
                        }
                        break;
                    default:
                        movementTypeLocal = 0;
                        break;
                }
            } else {
                movementTypeLocal = 0;
            }

            if (movementTypeLocal !== 0) {
                momeventDateLocal = dateTimeFormatGlobalSet({
                    date: bankAccountMovement?.movement?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (movementTypeLocal === 1) {
                if (!isUndNullEmp({ data: bankAccountMovement?.movement?.concilationStatus, subMethod: currentMethod, })?.result &&
                    bankAccountMovement?.movement?.concilationStatus === 'S') {
                    momeventConcilationDateLocal = dateTimeFormatGlobalSet({
                        date: bankAccountMovement?.movement?.concilationDate || new Date(),
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                } else {
                    momeventConcilationDateLocal = dateTimeFormatGlobalSet({
                        date: bankAccountMovement?.movement?.created || new Date(),
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                }

                if (bankAccountMovement?.collection !== dbColle?.bankAccountMovements) {
                    momeventConcilationRemarkLocal = bankAccountMovement?.movement?.conciliationRemark || '';
                } else {
                    momeventConcilationRemarkLocal = bankAccountMovement?.movement?.remark || '';
                }

                if (bankAccountMovement?.collection !== dbColle?.bankAccountMovements) {
                    setMovementOriginNumber(bankAccountMovement?.apartment?.identifier || '');
                    setMovementOriginDocument(bankAccountMovement?.apartmentReceipt?.receiptNumberApartment || '');
                    setMovementOriginDate(
                        dateTimeFormatGlobalSet({
                            date: bankAccountMovement?.apartmentReceipt?.created,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result
                    );
                }
            } else if (movementTypeLocal === -1) {
                if (bankAccountMovement?.collection !== dbColle?.bankAccountMovements) {
                    setMovementOriginDocument(bankAccountMovement?.purchase?.purchase?.number || '');
                    setMovementOriginNumber(bankAccountMovement?.purchase?.purchase?.invoiceNumber || '');
                    setControlNumer(bankAccountMovement?.purchase?.purchase?.invoiceControlNumber || '')
                    setSupplier(bankAccountMovement?.purchase?.supplier);
                    setMovementOriginDate(
                        dateTimeFormatGlobalSet({
                            date: bankAccountMovement?.purchase?.purchase?.date,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result
                    );
                }
                momeventConcilationDateLocal = dateTimeFormatGlobalSet({
                    date: bankAccountMovement?.movement?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result
            }

            setUserConcilation(`${bankAccountMovement?.userConciliation?.firstName || ''}, ${bankAccountMovement?.userConciliation?.lastName || ''}`);
            //#endregion validations

            //#region data set
            setMovementType(movementTypeLocal);
            setMovementDate(momeventDateLocal);
            setMovementConcilationDate(momeventConcilationDateLocal);
            setMovementConcilationRemark(momeventConcilationRemarkLocal);
            setMovementTypeDescription(movementTypeLocal === 1 ? labels?.income?.[languageObj?.id] : (movementTypeLocal === -1 ? labels?.egress?.[languageObj?.id] : ''));
            //#endregion data set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    // //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    // $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    // $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.inputs?.date?.id}`).attr({ readOnly: (processType !== 0), });
            // $(`#${controls?.selects?.type?.id}`).attr({ disabled: (processType !== 0), });
            // $(`#${controls?.inputs?.reference?.id}`).attr({ readOnly: (processType !== 0), });
            // $(`#${controls?.inputs?.amount?.id}`).attr({ readOnly: (processType !== 0), });
            // $(`#${controls?.inputs?.remark?.id}`).attr({ readOnly: (processType !== 0), });
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            // $(`#${controls?.dataTables?.movements?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.movements?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        datGetAsync({
            subMethod: 'form - onSubmit'
        });
    }, [showModal]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' onHide={() => defaultValueSetAsync(true)} show={showModal}>
            <Modal.Header>
                <Modal.Title>
                    <img alt='bankAccountMovement'
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.movementsLogo}></img> - {labels?.movement?.[languageObj?.id]} ({labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.type?.[languageObj?.id]}:
                    </div>
                    <div className={`col-md-8 ${movementType === 1 ? 'text-success' : 'text-danger'}`}>
                        <b>{movementTypeDescription}</b>
                    </div>
                </div>

                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.date?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{movementDate} </b>
                    </div>
                </div>

                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.reference?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{bankAccountMovement?.movement?.reference || ''}
                        </b>
                    </div>
                </div>

                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.amount?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{
                            separatorsNumbersSet({
                                number: movementType === 1 ? bankAccountMovement?.movement?.amount : bankAccountMovement?.movement?.amount * -1,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: 'lbl - amount',
                            })?.result
                        }</b>
                    </div>
                </div>

                <hr />

                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.origin?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{movementOrigin} </b>
                    </div>
                </div>

                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {movementCollection === dbColle?.purchasePayments ?
                            labels?.number?.[languageObj?.id] :
                            movementCollection === dbColle?.apartmentReceiptPayments ?
                                labels?.receipt?.[languageObj?.id] :
                                labels?.identifier?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{movementCollection === dbColle?.purchasePayments ?
                            movementOriginDocument :
                            movementCollection === dbColle?.apartmentReceiptPayments ?
                                movementOriginDocument :
                                movementOriginNumber
                        }</b>
                    </div>
                </div>

                {!isUndNullEmp({ data: movementCollection, subMethod: currentMethod, })?.result &&
                    movementCollection !== dbColle?.bankAccountMovements ?
                    <div>
                        <div className='row text-muted'>
                            <div className='col-md-4'>
                                {movementType === 1 ?
                                    movementCollection === dbColle?.apartmentReceiptPayments ?
                                        labels?.identifier?.[languageObj?.id] :
                                        labels?.receipt?.[languageObj?.id] :
                                    movementType === -1 ?
                                        movementCollection === dbColle?.purchasePayments ?
                                            labels?.purchase?.[languageObj?.id] :
                                            labels?.number?.[languageObj?.id] :
                                        ''}:
                            </div>
                            <div className='col-md-8'>
                                <b>{movementCollection === dbColle?.purchasePayments ?
                                    movementOriginNumber :
                                    movementCollection === dbColle?.apartmentReceiptPayments ?
                                        movementOriginNumber :
                                        movementOriginDocument
                                }</b>
                            </div>
                        </div>

                        {movementCollection === dbColle?.purchasePayments ?
                            <div>
                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {labels?.controlNumber?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{controlNumber} </b>
                                    </div>
                                </div>

                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {labels?.supplier?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{supplier?.description || ''} </b>
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                        }

                        <div className='row text-muted'>
                            <div className='col-md-4'>
                                {labels?.date?.[languageObj?.id]}:
                            </div>
                            <div className='col-md-8'>
                                <b>{movementOriginDate} </b>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
                }

                <hr />

                {movementType === 1 || movementType === -1 ?
                    <div>
                        {!isUndNullEmp({ data: movementCollection, subMethod: currentMethod, })?.result &&
                            movementCollection !== dbColle?.bankAccountMovements ?
                            <div>
                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {labels?.reconcilied?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <div className='icheck-primary d-inline'>
                                            <input checked
                                                id={chkReconcileId}
                                                readOnly
                                                type='checkbox' />
                                            <label htmlFor={chkReconcileId}></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                        }

                        <div className='row text-muted'>
                            <div className='col-md-4'>
                                {labels?.date?.[languageObj?.id]}:
                            </div>
                            <div className='col-md-8'>
                                <b>{movementConcilationDate}</b>
                            </div>
                        </div>

                        {/* <div className='row text-muted'>
                            <div className='col-md-4'>
                                {labels?.remark?.[languageObj?.id]}:
                            </div>
                            <div className='col-md-8'>
                                <b>{movementConcilationRemark}</b>
                            </div>
                        </div> */}

                        {!isUndNullEmp({ data: movementCollection, subMethod: currentMethod, })?.result &&
                            movementCollection !== dbColle?.bankAccountMovements ?
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.remark?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{movementConcilationRemark}</b>
                                </div>
                            </div>
                            :
                            <></>
                        }

                    </div>
                    :
                    <></>
                }

                {/* {movementType === -1 ?
                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.date?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{movementConcilationDate}</b>
                        </div>
                    </div>
                    :
                    <></>
                } */}

                {movementType === -1 &&
                    movementCollection === dbColle?.bankAccountMovements ?
                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.remark?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{bankAccountMovement?.movement?.remark || ''}
                            </b>
                        </div>
                    </div>
                    :
                    <></>
                }

                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.user?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{userConcilation}</b>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className='form-group text-right'>
                    <button id={controls?.buttons?.back?.id}
                        className={controls?.buttons?.back?.className}
                        tooltip='tooltip'
                        title={labels?.close?.[languageObj?.id]}
                        type='button'
                        onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}